export default function isClinicalTrialSite(siteValue: string) {
  try {
    const siteArray = (process.env.NEXT_PUBLIC_CLINICAL_TRIALS_SITE || 'ClinicalResearch')?.split(
      '|'
    );
    if (siteArray?.includes(siteValue)) {
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
}
